<template>
	<v-navigation-drawer
		v-if="currentRoute"
		v-model="drawer"
		app
		temporary
		width="300"
	>
		<v-list nav dense>
			<v-list-item color="primary">
				<svg viewBox="0 0 1320 300">
					<text x="45%" y="50%" dy=".35em" text-anchor="middle">
						GESPYM
					</text>
				</svg>
				<!-- <v-list-item-avatar class="rounded-0">
                    <v-img src="/favicon.ico"></v-img>
                </v-list-item-avatar>

                <div class="text-h4" style="font-family: Dosis !important">
                    MASMANAGER
                </div> -->
			</v-list-item>

			<v-divider />

			<v-list-item two-line>
				<v-list-item-avatar>
					<v-icon size="50"> mdi-account-circle </v-icon>
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title>{{ fullName }}</v-list-item-title>
					<v-list-item-subtitle>{{ rol }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider />
			<v-list-item
				v-for="(item, index) in processItemsGroupAndRoles"
				:key="index"
				:color="item.color"
				link
				:to="{ name: item.route }"
			>
				<v-list-item-icon>
					<v-icon>{{ item.icon }}</v-icon>
				</v-list-item-icon>
				<v-list-item-title>{{ item.title }}</v-list-item-title>
			</v-list-item>
		</v-list>

		<template v-slot:append>
			<v-divider></v-divider>
			<v-btn text href="/logout" class="d-flex justify-center my-3">
				<v-icon color="#bb0d00">mdi-logout</v-icon>
				<div class="font-weight-normal"> Log out </div>
			</v-btn>
			<div class="pa-2 d-flex justify-center" @click="addClickToTenant()">
				<small>
					<small class="font-weight-thin"
						>Gespym v7.0.1 (kiwi)</small
					></small
				>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
	name: 'SideBar',

	data: () => ({
		mini: true,
		noSidebarRoutes: ['maintenance'],
		onlySuperAdminRoutes: ['databaseManagement'],
	}),
	computed: {
		listItems() {
			return [
				{
					title: 'Dashboard',
					icon: 'mdi-chart-bar',
					route: 'dashboard',
					color: 'primary',
					groups: this.ERP_GROUPS,
					role: null,
				},
				{
					title: 'Gerencia',
					icon: 'mdi-car-cruise-control',
					route: 'gerencia',
					color: 'primary',
					groups: this.ERP_GROUPS,
					role: this.rolesEncoded.Manager,
				},
				{
					title: 'Teletrabajo',
					icon: 'mdi-face-agent',
					route: 'teletrabajo',
					color: 'primary',
					groups: this.ERP_GROUPS,
					role: null,
				},
				{
					title: 'RetailX',
					icon: 'mdi-storefront',
					route: 'retailX',
					color: 'red',
					groups: [this.GROUPS.VODAFONE],
					role: this.rolesEncoded.Admin,
				},
				{
					title: 'ÁreaPersonal',
					icon: 'mdi-basket-plus-outline',
					route: 'areaPersonal',
					color: 'primary',
					groups: this.ERP_GROUPS,
					role: null,
				},
				{
					title: 'Fichaje',
					icon: 'mdi-timer-outline',
					route: 'fichaje',
					color: 'primary',
					groups: [this.GROUPS.PUNCH_IN],
					role: null,
				},
				{
					title: 'Vacaciones',
					icon: 'mdi-beach',
					route: 'vacaciones',
					color: 'primary',
					groups: [],
					role: null,
				},
				{
					title: 'Mis Documentos',
					icon: 'mdi-folder-account-outline',
					route: 'documentos',
					color: 'primary',
					groups: [this.GROUPS.STORAGE],
					role: null,
				},
				{
					title: 'Administración',
					icon: 'mdi-controller-classic',
					route: 'managementBase',
					color: 'primary',
					groups: this.ERP_GROUPS,
					role: this.rolesEncoded.Admin,
				},
				{
					title: 'Dispositivos',
					icon: 'mdi-cellphone',
					route: 'devicemanagement',
					color: 'primary',
					groups: [this.GROUPS.MASMOVIL],
					role: null,
				},
				// {
				// 	title: 'Tutoriales',
				// 	icon: 'mdi-school-outline',
				// 	route: 'tutorials',
				// 	color: 'primary',
				// 	groups: [],
				// 	role: null,
				// },
				{
					title: 'RRHH',
					icon: 'mdi-account-group',
					route: 'rrhh',
					color: 'primary',
					groups: [],
					role: this.rolesEncoded.Admin,
				},
				{
					title: 'Lowi',
					icon: 'mdi-microsoft-excel',
					route: 'lowi',
					color: 'primary',
					groups: [this.GROUPS.LOWI],
					role: null,
				},
				{
					title: 'Database Management',
					icon: 'mdi-database-edit',
					route: 'databaseManagement',
					color: 'red',
					groups: [],
					role: this.rolesEncoded.SuperAdmin,
				},
			];
		},
		processItemsGroupAndRoles() {
			if (!this.listItems) {
				return [];
			}

			return this.listItems.filter((item) => {
				return (
					this.checkRolePermission(item.role) &&
					this.ckeckGroupPermission(item.groups) &&
					!this.checkClickstoTenantAndAOnlySuperAdmin(item)
				);
			});
		},
		currentRoute() {
			return !this.noSidebarRoutes.includes(this.$route.name);
		},
		rol() {
			return this.$store.state.general.rolesDecode[this.rolEncoded];
		},
		drawer: {
			get() {
				return this.$store.state.general.IsOpenSideBar;
			},
			set(val) {
				if (!val) this.$store.dispatch('general/closeSideBar');
			},
		},
        ...mapState('rrhh', {
            clicksToTenant: (state) => state.clicksToTenant,
        }),
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
			ERP_GROUPS: (state) => state.ERP_GROUPS,
			rolesEncoded: (state) => state.rolesEncode,
		}),
		...mapState('login', {
			fullName: (state) => state.nombre,
			rolEncoded: (state) => state.rol,
			groups: (state) => state.groups,
		}),
		...mapGetters('login', {
			checkRolePermission: 'checkRolePermission',
			ckeckGroupPermission: 'ckeckGroupPermission',
			hasManagerPermission: 'hasManagerPermission',
			hasSuperAdminPermission: 'hasSuperAdminPermission',
		}),
	},
	methods: {
		checkClickstoTenantAndAOnlySuperAdmin(item) {
			const clicksToTenant = 7;
			
			return this.onlySuperAdminRoutes.includes(item.route) && this.clicksToTenant <= clicksToTenant; 
		},
		addClickToTenant() {
			if (this.hasSuperAdminPermission) {
				if (this.$store.state.rrhh.clicksToTenant >= 7) {
					this.$store.dispatch('util/showStatusSnackBar', {
						statusType: 'success',
						message: 'Ya dispones del modo desarollador!',
					});
				} else if (this.$store.state.rrhh.clicksToTenant > 4) {
					this.$store.dispatch('util/showStatusSnackBar', {
						statusType: 'success',
						message:
							'Estás a ' +
							(
								8 - this.$store.state.rrhh.clicksToTenant
							).toString() +
							' clicks de disponer de los ajustes de desarrollador',
					});
				}

				if (this.$store.state.rrhh.clicksToTenant <= 7)
					this.$store.state.rrhh.clicksToTenant++;
			}
		},
	},
};
</script>

<style scoped>
body {
	background: #ffffff;
}

svg {
	font-family: Dosis !important;
	position: absolute;
	width: 100%;
	height: 100%;
}
svg text {
	text-transform: uppercase;
	animation: stroke 5s infinite alternate;
	stroke-width: 2;
	stroke: #ffc800;
	font-size: 300px;
}
@keyframes stroke {
	0% {
		fill: rgba(72, 138, 20, 0);
		stroke: rgb(212, 159, 0);
		stroke-dashoffset: 25%;
		stroke-dasharray: 0 50%;
		stroke-width: 2;
	}
	20% {
		fill: rgba(72, 138, 20, 0);
		stroke: rgb(128, 163, 0);
	}
	40% {
		fill: rgba(72, 138, 20, 0);
		stroke: rgb(172, 0, 103);
		stroke-width: 3;
	}
	100% {
		fill: rgb(0, 0, 0);
		stroke: rgb(0, 0, 0);
		stroke-dashoffset: -25%;
		stroke-dasharray: 50% 0;
		stroke-width: 0;
	}
}
</style>
